export default class SearchSportsCamps {
	constructor(el) {
		this.el = el;
		this.triggerMobileFilter = null;
		this.init();
		this.initEvents();
	}

	init() {
		this.triggerMobileFilter = document.querySelector(
			".c-sidebar-nav-mobile-title"
		);
	}

	initEvents() {
		this.triggerMobileFilter.addEventListener("click", (e) => {
			e.preventDefault();
			this.toggleFilter(e);
		});
	}

	toggleFilter(e) {
		this.triggerMobileFilter.classList.toggle("open");
		this.triggerMobileFilter
			.querySelector(".fa-angle-down")
			.classList.toggle("rotate");
	}
}
